import "../Style.css"; import "../Responsive.css";
import "../bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { CanUseWarrantyDetails } from "../core/ModuleHelper";
import {
  styled,
  Radio,
  Switch,
  TextField,
  Button,
  Container,
  Box,
  Grid,
  Paper,
  Typography,
  Stack,
  FormControlLabel,
  FormControl,
  IconButton,
  Tooltip,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  Input,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Utils from "../core/Utils";
import UserHelper from "../core/UserHelper";
import BusinessHelper from "../core/BusinessHelper";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import SideBarMenuItems from "./SideBarMenuItems";
import ConfirmPopup from "./common/ConfirmPopup";
import SettingsMenuItems from "./SettingsMenuItems";
import {
  SideBarMenuNames,
  SettingsMenuList,
  ConfirmTypes,
  VehicleTypes,
  India,
  UAE,
  USA,
  AlertSMSNotSupported,
  MaxFileSizeLimit,
} from "../core/Constants";
import { connectToStore } from "../data/store";
import { postAsync, getGeocodeAddress } from "../core/serviceClient";
import { setBranch, setBusiness } from "../data/localSettingsActions";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import {
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import NumericTextField from "./common/controls/NumericTextField";
import moment from "moment";
import AutoMobileHelper from "../core/AutomobileHelper";
import CountryHelper from "../core/CountryHelper";
import {
  AddNewBranchPage,
  BranchSetupPage,
  LoginPage,
} from "../core/PageConstants";
import AddressField from "./common/controls/AddressField";
import { Regexes } from "../core/Regexes";
import { CanUseProductStockReport } from "../core/ModuleHelper";
import { CenterFocusStrong, Label } from "@mui/icons-material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteIcon from "@mui/icons-material/Delete";
import { ImageEnlarge } from "./common/ImageEnlarge";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const AddNewBranch = (props) => {
  document.title = "Add New Branch";
  const navigate = useNavigate();

  const location = useLocation();
  const dispatch = useDispatch();
  const [localSettings, setLocalSettings] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [navigateTo, setNavigateTo] = useState(false);
  const [confirmFor, setConfirmFor] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [branchName, setBranchName] = useState("");
  const [branchAddress, setBranchAddress] = useState("");
  const [registrationId, setRegistrationId] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [automaticMessage, setAutomaticMessage] = useState(false);
  const [allowPartialPayments, setAllowPartialPayments] = useState(false);
  const [taxPercent, setTaxPercent] = useState("");
  const [corporate, setCorporate] = useState(false);
  const [invoicePrefix, setInvoicePrefix] = useState("");
  const [invoiceSuffix, setInvoiceSuffix] = useState("");
  const [warrantyPrefix, setwarrantyPrefix] = useState("");
  const [contactName, setContactName] = useState("");
  const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState("");
  const [contactPhoneNumber, setContactPhoneNumber] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [receiptCaption, setReceiptCaption] = useState("");
  const [payments, setPayments] = useState(false);
  const [payouts, setPayouts] = useState(false);
  const [autoPay, setAutoPay] = useState(false);
  const [immediate, setImmediate] = useState(false);
  const [acceptReservations, setAcceptReservations] = useState("");
  const [businessOpen, setBusinessOpen] = useState(Utils.GetStartDate());
  const [businessClose, setBusinessClose] = useState(Utils.GetStartDate());
  const [maxDays, setMaxDays] = useState("");
  const [timeSlotIntMins, setTimeSlotIntMins] = useState("");
  const [reservationsPerTimeSlot, setReservationsPerTimeSlot] = useState("");
  const [reserveService, setReserveService] = useState(false);
  const [reservationAtUserLevel, setReservationAtUserLevel] = useState(false);
  const [reservationPaymentRefundable, setReservationPaymentRefundable] =
    useState(false);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [pageTitle, setPageTitle] = useState("Add New Branch");
  const [taxIdLbl, setTaxIdLbl] = useState("Business Tax Id");
  const [vehicleList, setVehicleList] = useState([]);
  const [fetchServiceLocations, setFetchServiceLocations] = useState(false);
  const [isOdometerReadingsMandatory, setIsOdometerReadingsMandatory] =
    useState(false);
  const [businessCountry, setBusinessCountry] = useState("");
  const [openInvoice, setOpenInvoice] = useState(false);
  const [invoiceDesc, setInvoiceDesc] = useState("");
  const [invoiceTax, setInvoiceTax] = useState(false);
  const [invoiceActive, setInvoiceActive] = useState(false);
  const [invoiceLabels, setInvoiceLabels] = useState([]);
  const [reservationConfirmedByCustomer, setReservationConfirmedByCustomer] =
    useState(false);
  const [reservationPaymentRequired, setReservationPaymentRequired] =
    useState(false);
  const [reservationPaymentPercent, setReservationPaymentPercent] =
    useState("");
  const [sendServiceReminder, setSendServiceReminder] = useState(false);
  const [sendReservationReminder, setSendReservationReminder] = useState(false);
  const [daysToRemindBeforeService, setDaysToRemindBeforeService] =
    useState("");
  const [sendReminderTriggerTime, setSendReminderTriggerTime] = useState(
    moment(Utils.GetStartDate(), "HH:mm:ss")
  );
  const [jobTypes, setJobTypes] = useState(AutoMobileHelper.GetJobTypes());
  const [inventoryItems, setInventoryItems] = useState(
    AutoMobileHelper.GetInventoryItems()
  );
  const [openJobType, setOpenJobType] = useState(false);
  const [regIdLength, setRegIdLength] = useState(0);
  const [jobType, setJobType] = useState("");
  const [openInventory, setOpenInventory] = useState(false);
  const [inventory, setInventory] = useState({});
  const [isAutomobile, setIsAutomobile] = useState(
    BusinessHelper.IsAutomobile()
  );
  const [selectedVehicle, setSelectedVehicle] = useState(VehicleTypes.FourWheeler);
  const [branchAddressISOCode, setBranchAddressISOCode] = useState({});
  const [isBillingInventoryTrack, setIsBillingInventoryTrack] = useState(false);
  const [isBackDateInvoice, setIsBackDateInvoice] = useState(false);
  const [isProductStockReport, setIsProductStockReport] = useState(false);
  const [isAllowStylists, setIsAllowStylists] = useState(false);
  const [isAuthenticationPinRequired, setIsAuthenticationPinRequired] = useState(false);
  const [isTaxBracket, setIsTaxBracket] = useState(false);
  const [municipalTax, setMunicipalTax] = useState("7");
  const [isAllowMunicipalTax, setIsAllowMunicipalTax] = useState(false);
  const [reservationImageUrl, setReservationImageUrl] = useState("");
  const [enlargeImage, setEnlargeImage] = useState(false);
  const [addPromotionalImages, setAddPromotionalImages] = useState([]);
  const [selectedDeleteImage, setSelectedDeleteImage] = useState(0);
  const [selectedEnlargeImage, setSelectedEnlargeImage] = useState("");
  const [isIssueApprovalRequired, setIsIssueApprovalRequired] = useState(false);
  const [googleReviewURL, setGoogleReviewURL] = useState("");


  // payment link settings
  const [allowPaymentLinks, setAllowPaymentLinks] = useState(false);

  //Description in Invoice
  const [isDescriptionInInvoice, setIsDescriptionInInvoice] = useState(false);

  let vehicles = [
    {
      value: VehicleTypes.FourWheeler,
      isChecked: false,
    },
    {
      value: VehicleTypes.TwoWheeler,
      isChecked: false,
    },
  ];

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (navigateTo == "Login") {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    } else if (navigateTo == "Branches") {
      navigate(BranchSetupPage.Path);
    }
  };

  const handleConfirmClose = (value) => {
    setConfirmOpen(false);
    if (value == ConfirmTypes.OK) {
      if (confirmFor == "Invoice") {
        processInvoiceSave();
      }
      if (confirmFor == "Update") {
        branchSetupSubmit();
      }
      if (confirmFor == "DeleteReservationPhoto") {
        handleCloseConfirm(value);
      }
      if (confirmFor == "DeletePromotionalPhoto") {
        handleCloseConfirmPromotional(value);
      }
    }
  };
  useEffect(() => {
    let localSetting = connectToStore();
    if (UserHelper.CheckPermission(AddNewBranchPage, navigate, localSetting)) {
      moment.locale(CountryHelper.GetDateCulture(localSetting.country.Culture));
      setLocalSettings(localSetting);
      let country = CountryHelper.GetCountryObject(
        localSetting.business.branchLocations.filter(x => x.branchId)[0].countryCode
      );
      setBusinessCountry(country);
      var productStock = CanUseProductStockReport(localSetting.business);
      if (productStock === true) {
        setIsProductStockReport(true);
      }
      setBranchAddressISOCode(country.ISOCode);
      if (country.ShortName === India.ShortName) {
        setTaxIdLbl("GSTIN Number");
      }
      else if (country.ShortName === UAE.ShortName) {
        setTaxIdLbl("TRN No");
      }
      setRegIdLength(15);
      var branch = location.state && location.state.selectedBranch;
      if (!Utils.IsNullOrEmptyObject(branch)) {
        setSelectedBranch(branch);
        setPageTitle("Update Branch: " + branch.branchName);
        setBranchName(branch.branchName);
        setBranchAddress(branch.address);
        setPayments(branch.paymentsEnabled);
        setPayouts(branch.payoutsEnabled);
        setAutoPay(branch.autoPayEnabled);
        setAllowPartialPayments(branch.allowMultiplePayments);
        setIsAuthenticationPinRequired(branch.authenticationPinRequired);
        setIsIssueApprovalRequired(branch.issueApprovalRequired);
        setIsTaxBracket(branch.isTaxBracket);
        setIsDescriptionInInvoice(branch.showItemDescriptionInInvoice);
        setRegistrationId(branch.registrationId);
        setStateCode(branch.stateCode);
        setTaxPercent(branch.taxPercent);
        setAutomaticMessage(branch.sendAutomaticMessage);
        setCorporate(branch.corporate);
        setInvoicePrefix(branch.invoicePrefix);
        setInvoiceSuffix(branch.invoiceSuffix);
        setwarrantyPrefix(branch.warrantyPrefix);
        setContactName(branch.contactName);
        setAdditionalPhoneNumber(branch.additionalPhoneNumber);
        setIsBillingInventoryTrack(branch.isBillingInventoryTrack);
        setIsBackDateInvoice(branch.invoiceToPreviousDate)
        setContactPhoneNumber(branch.contactPhoneNumber);
        setContactEmail(branch.contactEmailId);
        setReceiptCaption(branch.receiptCaption);
        // setBusinessOpen(moment(branch.startTime, "HH:mm:ss"));
        // setBusinessClose(moment(branch.endTime, "HH:mm:ss"));
        const isDefaultTime =
          branch.startTime === "00:00:00" &&
          branch.endTime === "00:00:00";

        const openTime = isDefaultTime
          ? moment(branch.serviceStartTime, "HH:mm:ss")
          : moment(branch.startTime, "HH:mm:ss");

        const closeTime = isDefaultTime
          ? moment(branch.serviceEndTime, "HH:mm:ss")
          : moment(branch.endTime, "HH:mm:ss");

        setBusinessOpen(openTime);
        setBusinessClose(closeTime);

        setSelectedVehicle(branch.vehicleType);
        setFetchServiceLocations(branch.fetchServiceLocations);
        setIsOdometerReadingsMandatory(branch.isOdometerReadingsMandatory);
        setAcceptReservations(branch.reservationsDisabled == false);
        setReserveService(branch.reserveProducts);
        setReservationAtUserLevel(branch.reservationAtUserLevel);
        setReservationConfirmedByCustomer(
          branch.reservationConfirmedByCustomer
        );
        setGoogleReviewURL(branch.branchGoogleReviewURL);
        setImmediate(branch.autoPayImmediate);
        setMaxDays(branch.reservationMaxDays);
        setTimeSlotIntMins(branch.reservationTimeInterval);
        setReservationsPerTimeSlot(branch.reservationCountPerSlot);
        setReservationPaymentRequired(branch.reservationPaymentRequired);
        setReservationPaymentPercent(branch.reservationPaymentPercent);
        setReservationPaymentRefundable(branch.reservationPaymentRefundable);
        setFetchServiceLocations(branch.fetchServiceLocations);
        setSendServiceReminder(branch.sendServiceReminder);
        setSendReservationReminder(branch.sendReservationReminder);
        setDaysToRemindBeforeService(branch.daysToRemindBeforeService);
        setIsAllowMunicipalTax(branch.isAllowMunicipalTax);
        if (branch.isAllowMunicipalTax) {
          setMunicipalTax(branch.municipalTax);
        }
        if (!Utils.IsNullOrEmpty(branch.reservationBranchImageUrl)) {
          setReservationImageUrl(branch.reservationBranchImageUrl)
        }
        if (!Utils.IsNullOrEmptyArray(branch.promotionalImages)) {
          let storeImages = [];
          branch.promotionalImages.forEach((item) => {
            if (item.imageUrl) {
              storeImages.push(item.imageUrl)
            }
          })
          setAddPromotionalImages(storeImages);


        }
        setSendReminderTriggerTime(
          moment(branch.sendReminderTriggerTime, "HH:mm:ss")
        );
        setIsAllowStylists(branch.allowStylists);
        setInvoiceLabels(branch.invoiceLabels);
        if (!Utils.IsNullOrEmptyArray(branch.jobTypes)) {
          setJobTypes(branch.jobTypes);
        }
        if (!Utils.IsNullOrEmptyArray(branch.inventoryItem)) {
          var tempInventoryItems = [];
          Object.entries(branch.inventoryItem).forEach(([key, value]) => {
            tempInventoryItems.push({
              name: key,
              isChecked: value,
            });
          });
          setInventoryItems(tempInventoryItems);
        }
      } else {
        vehicles[0].isChecked = true;
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    let errorMsg = "";
    var validRegistrationId = Utils.IsNullOrEmpty(registrationId);
    if (businessCountry.ShortName === India.ShortName) {
      if (!validRegistrationId) {
        validRegistrationId =
          registrationId.length === regIdLength &&
          Regexes.GST.test(registrationId);
      }
      if (!validRegistrationId) {
        errorMsg += "Please enter a valid GSTIN number.<br />";
      }
    }
    else if (businessCountry.ShortName === UAE.ShortName) {
      if (!validRegistrationId) {
        validRegistrationId = registrationId.length === regIdLength
      }
      if (!validRegistrationId) {
        errorMsg += "Please enter a valid TRN Number.<br />";
      }
    } else if ((businessCountry.ShortName === USA.ShortName && regIdLength === 15)) {
      if (!validRegistrationId) {
        validRegistrationId = registrationId.length === regIdLength
      }
      if (!validRegistrationId) {
        errorMsg += "Please enter a valid business tax id.<br />";
      }
    }
    if (Utils.IsNullOrEmpty(branchName)) {
      errorMsg += "Please enter the branch name.<br />";
    }
    if (Utils.IsNullOrEmpty(branchAddress)) {
      errorMsg += "Please enter the branch address.<br />";
    }
    if (businessCountry == USA.ShortName && Utils.IsNullOrEmpty(taxPercent)) {
      errorMsg += "Please enter the tax percent.<br />";
    }
    if (Utils.IsNullOrEmpty(contactName)) {
      errorMsg += "Please enter the contact name.<br />";
    }
    if (Utils.IsNullOrEmpty(contactPhoneNumber)) {
      errorMsg += "Please enter the contact mobile number.<br />";
    } else if (
      !Utils.IsMobileValid(contactPhoneNumber)
    ) {
      errorMsg += "Please enter the valid contact mobile number.<br />";
    }
    if (
      !Utils.IsNullOrEmpty(additionalPhoneNumber) &&
      !Utils.IsMobileValid(additionalPhoneNumber)
    ) {
      errorMsg += "Please enter the valid additional phone number.<br />";
    }
    if (Utils.IsNullOrEmpty(contactEmail)) {
      errorMsg += "Please enter the contact email.<br />";
    } else if (!Utils.IsEmailValid(contactEmail)) {
      errorMsg += "Please enter the valid contact email.<br />";
    }
    if (!Utils.IsNullOrEmpty(googleReviewURL)) {
      if (!Utils.IsURLValid(googleReviewURL))
        errorMsg += "Please enter the valid google review url.<br />";
    }
    if (acceptReservations) {
      if (Utils.IsNullOrEmpty(maxDays)) {
        errorMsg += "Please enter the max days.<br />";
      }
      if (Utils.IsNullOrEmpty(timeSlotIntMins)) {
        errorMsg += "Please enter the time slot interval minutes.<br />";
      }
      if (Utils.IsNullOrEmpty(reservationsPerTimeSlot)) {
        errorMsg += "Please enter the reservation per time slot.<br />";
      }
    }
    if (businessCountry == USA.ShortName && reservationPaymentRequired) {
      errorMsg += "Please enter the payment percent.<br />";
    }
    if (businessOpen._isValid == false) {
      if (acceptReservations)
        errorMsg += "Business opening time is not valid.";
      else
        setBusinessOpen(Utils.GetStartDate());
    }
    if (businessClose._isValid == false) {
      if (acceptReservations)
        errorMsg += "Business opening time is not valid.";
      else
        setBusinessClose(Utils.GetStartDate());
    }

    if (acceptReservations && businessOpen > businessClose) {
      errorMsg += "Business opening time should be before closing time.<br />";
    }
    if (
      !Utils.IsNullOrEmptyArray(invoiceLabels) &&
      !invoiceLabels.some((item) => item.active === true)
    ) {
      errorMsg +=
        "At least one active invoice label required before proceeding.<br />";
    }
    if (sendReminderTriggerTime._isValid == false) {
      if (sendServiceReminder)
        errorMsg += "Service reminder start time is not valid."
      else
        setSendReminderTriggerTime(Utils.GetStartDate());
    }
    if (sendReminderTriggerTime._isValid == false) {
      if (sendReservationReminder)
        errorMsg += "Reservation reminder start time is not valid."
      else
        setSendReminderTriggerTime(Utils.GetStartDate());
    }
    if (isAllowMunicipalTax && !municipalTax) {
      errorMsg += "Please enter the municipal tax percent.<br />"
    }

    if (!Utils.IsNullOrEmpty(errorMsg)) {
      setMsgText(errorMsg);
      setMsgOpen(true);
    } else {
      setConfirmFor("Update");
      setConfirmText("Are you sure you want to save changes?");
      setConfirmOpen(true);
    }
  };

  async function branchSetupSubmit() {
    setIsLoading(true);
    const imgObj = getImgObj(reservationImageUrl);
    let storePromotionalImages = [];
    if (!Utils.IsNullOrEmptyArray(addPromotionalImages)) {
      addPromotionalImages.forEach((item) => {
        let result = getImgObj(item);
        let obj = {
          imageUrl: result.url,
          expiryDT: "01/01/0001 00:00:00"
        };
        storePromotionalImages.push(obj);
      })
    }
    let newBranch = {
      ...selectedBranch,
      branchName: branchName,
      address: branchAddress,
      allowMultiplePayments: allowPartialPayments,
      authenticationPinRequired: isAuthenticationPinRequired,
      issueApprovalRequired: isIssueApprovalRequired,
      isTaxBracket: isTaxBracket,
      showItemDescriptionInInvoice: isDescriptionInInvoice,
      registrationId: Utils.ConvertToUpperCase(registrationId),
      stateCode: stateCode,
      taxPercent: Utils.ConvertToFloat(taxPercent),
      isBillingInventoryTrack: isBillingInventoryTrack,
      invoiceToPreviousDate: isBackDateInvoice,
      sendAutomaticMessage: automaticMessage,
      corporate: corporate,
      invoicePrefix: invoicePrefix,
      invoiceSuffix: invoiceSuffix,
      warrantyPrefix: warrantyPrefix,
      warrantyNumber: 0,
      contactName: contactName,
      contactPhoneNumber: contactPhoneNumber,
      additionalPhoneNumber: additionalPhoneNumber,
      contactEmailId: Utils.ConvertToLowerCase(contactEmail),
      receiptCaption: receiptCaption,
      serviceStartTime: Utils.GetISODateTimeString(moment(businessOpen)),
      serviceEndTime: Utils.GetISODateTimeString(moment(businessClose)),
      reservationMaxDays: Utils.ConvertToInteger(maxDays),
      reservationCountPerSlot: Utils.ConvertToInteger(reservationsPerTimeSlot),
      reservationTimeInterval: Utils.ConvertToInteger(timeSlotIntMins),
      reservationsDisabled: acceptReservations,
      vehicleType: isAutomobile ? selectedVehicle : VehicleTypes.None,
      reservationPaymentRefundable: reservationPaymentRefundable,
      reservationConfirmedByCustomer: reservationConfirmedByCustomer,
      reservationPaymentPercent: Utils.ConvertToFloat(
        reservationPaymentPercent
      ),
      reservationAtUserLevel: reservationAtUserLevel,
      reserveProducts: reserveService,
      paymentsEnabled: payments,
      payoutsEnabled: payouts,
      autoPayEnabled: autoPay,
      autoPayImmediate: immediate,
      reservationPaymentRequired: reservationPaymentRequired,
      reservationsDisabled: acceptReservations == false,
      allowStylists: isAllowStylists,
      isOdometerReadingsMandatory: isAutomobile && isOdometerReadingsMandatory,
      daysToRemindBeforeService: Utils.ConvertToInteger(
        daysToRemindBeforeService
      ),
      branchGoogleReviewURL: googleReviewURL,
      sendReminderTriggerTime: Utils.GetTimeOnly(
        moment(sendReminderTriggerTime, "HH:mm:ss tt")
      ),
      reservationBranchImageUrl: imgObj.url,
      promotionalImages: storePromotionalImages,
    };
    if (!Utils.IsNullOrEmptyObject(selectedBranch)) {
      newBranch.payout = selectedBranch.payout;
      newBranch.beacons = selectedBranch.beacons ? selectedBranch.beacons : [];
      if (selectedBranch.productsDT)
        newBranch.productsDT = selectedBranch.productsDT;
      newBranch.qrCodeUrl = selectedBranch.qrCodeUrl
        ? selectedBranch.qrCodeUrl
        : "";
      newBranch.reservationDocs = selectedBranch.reservationDocs
        ? selectedBranch.reservationDocs
        : [];
    } else {
      newBranch.reservationBlockedTimes = null;
      newBranch.productsDT = "0001-01-01T00:00:00";
      newBranch.beacons = null;
      newBranch.terminals = null;
      newBranch.payout = null;
      newBranch.status = "Active";
      newBranch.upi = null;
      newBranch.reservationDocs = null;
      newBranch.bankDetails = null;
      newBranch.serviceStartTime = "0001-01-01T00:00:00";
      newBranch.serviceEndTime = "0001-01-01T00:00:00";
      var branchLocations = [...localSettings.business.branchLocations];
      var branches = branchLocations.sort((a, b) =>
        a.branchId > b.branchId ? -1 : 1
      );
      let tempBranchId = Utils.ConvertToInteger(branches[0].branchId) + 1;
      let strBranchId = Utils.ConvertToString(tempBranchId);
      if (strBranchId.length == 1) {
        newBranch.branchId = "00" + strBranchId;
      } else if (strBranchId.length == 2) {
        newBranch.branchId = "0" + strBranchId;
      } else newBranch.branchId = strBranchId;
    }
    if (Utils.IsNullOrEmpty(newBranch.countryCode))
      newBranch.countryCode = businessCountry.Code;
    newBranch.sendReservationReminder = BusinessHelper.IsSalon() ? sendReservationReminder : false;
    if (isAutomobile) {
      newBranch.fetchServiceLocations = fetchServiceLocations;
      newBranch.sendServiceReminder = sendServiceReminder;
      newBranch.jobTypes = jobTypes;
      if (!Utils.IsNullOrEmptyArray(inventoryItems)) {
        let inventories = Object.fromEntries(
          inventoryItems.map((c) => [c.name, c.isChecked])
        );
        newBranch.inventoryItem = inventories;
      }
    } else {
      newBranch.fetchServiceLocations = false;
      newBranch.sendServiceReminder = false;
    }
    if (
      businessCountry &&
      (businessCountry == India.ShortName || businessCountry == UAE.ShortName)
    ) {
      let selectedVehicle = vehicleList.filter((v) => v.isChecked === true);
      newBranch.vehicleType = isAutomobile
        ? selectedVehicle[0].value
        : VehicleTypes.None;
    }
    if (!Utils.IsNullOrEmptyArray(invoiceLabels))
      newBranch.invoiceLabels = invoiceLabels;
    else {
      newBranch.invoiceLabels = [
        {
          active: true,
          taxIncluded: true,
          description:
            "INV" + localSettings.business.branchLocations.length + 1,
          invoiceNumber: 0,
        },
      ];
    }
    if (!Utils.IsNullOrEmpty(branchAddress)) {
      var geocodeResponse = await getGeocodeAddress(branchAddress);
      var locality = "",
        county = "",
        state = "",
        country = "",
        zipcode = "",
        streetNumber = "",
        route = "",
        address = branchAddress;
      let lat = 0,
        lng = 0;
      if (
        !Utils.IsNullOrEmptyObject(geocodeResponse) &&
        geocodeResponse.status === "OK" &&
        !Utils.IsNullOrEmptyArray(geocodeResponse.results) &&
        !Utils.IsNullOrEmptyObject(geocodeResponse.results[0])
      ) {
        let geoResult = geocodeResponse.results[0];
        address = geoResult.formatted_address;
        if (
          geoResult.address_components
            .map((c) => c.types)
            .includes("street_number") === true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("street_number")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) streetNumber = ac.long_name;
        }
        if (
          geoResult.address_components.map((c) => c.types).includes("route") ===
          true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("route")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) route = ac.long_name;
        }
        if (
          geoResult.address_components
            .map((c) => c.types)
            .includes("locality") === true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("locality")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) locality = ac.long_name;
        }
        if (
          geoResult.address_components
            .map((c) => c.types)
            .includes("administrative_area_level_1") === true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("administrative_area_level_1")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) state = ac.long_name;
        }
        if (
          geoResult.address_components
            .map((c) => c.types)
            .includes("administrative_area_level_2") === true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("administrative_area_level_2")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) county = ac.long_name;
        }

        if (
          geoResult.address_components
            .map((c) => c.types)
            .includes("country") === true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("country")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) country = ac.short_name;
        }

        if (
          geoResult.address_components
            .map((c) => c.types)
            .includes("postal_code") === true
        ) {
          var ac = geoResult.address_components.find((c) =>
            c.types.includes("postal_code")
          );
          if (!Utils.IsNullOrEmptyObject(ac)) zipcode = ac.long_name;
        }
        if (geoResult.geometry && geoResult.geometry.location) {
          lat = geoResult.geometry.location.lat;
          lng = geoResult.geometry.location.lng;
        }
      }
      newBranch.address =
        businessCountry && businessCountry == USA.ShortName
          ? address
          : branchAddress;
      newBranch.addressLine1 = streetNumber + " " + route;
      newBranch.city = locality;
      newBranch.state = state;
      newBranch.zipCode = zipcode;
      newBranch.country = country;
      newBranch.latitude = lat;
      newBranch.longitude = lng;
      newBranch.startTime = moment(businessOpen, "HH:mm:ss").format("HH:mm");
      newBranch.endTime = moment(businessClose, "HH:mm:ss").format("HH:mm");
      newBranch.isAllowMunicipalTax = isAllowMunicipalTax;
      newBranch.municipalTax = isAllowMunicipalTax ? municipalTax : 0;
      newBranch.reservationBranchImageUrl = imgObj.url;
      newBranch.promotionalImages = storePromotionalImages;
    }
    let response = await postAsync("Business/SaveBranch", {
      BusinessId: localSettings.business.id,
      Branch: newBranch,
    });
    if (response.isNavigateToLogin) setNavigateTo("Login");
    setIsLoading(false);
    if (response.error) {
      setMsgOpen(true);
      setMsgText(response.errorMessage);
    } else if (response.data) {
      setNavigateTo("Branches");
      setBusiness(response.data.business, dispatch);
      var updatedBranch = response.data.business.branchLocations.find(
        (bl) => bl.branchId == newBranch.branchId
      );
      setBranch(updatedBranch, dispatch);
      setMsgText("Changes saved successfully.");
      setMsgOpen(true);
    }
  }

  const processInvoiceSave = () => {
    var activeCount = Utils.IsNullOrEmptyArray(invoiceLabels)
      ? 0
      : invoiceLabels.filter((i) => i.active).length;
    if (invoiceActive && activeCount >= 5) {
      setMsgText("Maximum upto 5 active invoice labels can be added.");
      setMsgOpen(true);
      return;
    }
    let invoiceList = [...invoiceLabels];
    invoiceList.push({
      description: invoiceDesc,
      taxIncluded: invoiceTax,
      active: invoiceActive,
    });
    setInvoiceLabels(invoiceList);
  };
  const handleAddInvoice = () => {
    setInvoiceDesc("");
    setInvoiceActive(false);
    setInvoiceTax(false);
    setOpenInvoice(true);
  };
  const handleInvoiceClose = () => {
    setOpenInvoice(false);
  };
  const handleJobTypeClose = () => {
    setOpenJobType(false);
  };
  const handleInventoryClose = () => {
    setOpenInventory(false);
  };
  const handleJobTypeAdd = () => {
    setJobType("");
    setOpenJobType(true);
  };
  const handleInventoryAdd = () => {
    setInventory("");
    setOpenInventory(true);
  };
  // const handleJobTypeSave = () => {
  //   if (!Utils.IsNullOrEmpty(jobType)) {
  //     let jobtypes = [...jobTypes];
  //     jobtypes.push(jobType);
  //     setJobTypes(jobtypes);
  //   }
  //   setOpenJobType(false);
  // };
  const handleJobTypeSave = () => {
    if (!Utils.IsNullOrEmpty(jobType)) {
      let jobtypes = [...jobTypes];
      const exists = jobtypes.some(
        (job) => job.toLowerCase() === jobType.toLowerCase()
      );

      if (exists) {
        setMsgText("This job type already exists!");
        setMsgOpen(true);
        return;
      }
      jobtypes.push(jobType);
      setJobTypes(jobtypes);
    }
    setOpenJobType(false);
  };
  const handleJobTypeDelete = (index) => {
    let jobtypes = [...jobTypes];
    jobtypes.splice(index, 1);
    setJobTypes(jobtypes);
  };
  const handleInventorySave = () => {
    if (!Utils.IsNullOrEmpty(inventory)) {
      const exists = inventoryItems.some(
        (item) => item.name.toLowerCase() === inventory.toLowerCase()
      );

      if (exists) {
        setMsgText("This inventory item already exists!");
        setMsgOpen(true);
        return;
      }
      let inventories = [...inventoryItems];
      inventories.push({ name: inventory, isChecked: false });
      setInventoryItems(inventories);
    }
    setOpenInventory(false);
  };
  const handleInventoryDelete = (index) => {
    let inventories = [...inventoryItems];
    inventories.splice(index, 1);
    setInventoryItems(inventories);
  };
  const handleCommentsChange = (e, index) => {
    let inventories = [...inventoryItems];
    inventories[index].isChecked = e.target.checked;
    setInventoryItems(inventories);
  };

  const handleInvoiceSave = () => {
    if (Utils.IsNullOrEmpty(invoiceDesc)) {
      setMsgText("Please enter a valid description.");
      setMsgOpen(true);
    } else if (
      !Utils.IsNullOrEmptyArray(invoiceLabels) &&
      invoiceLabels.some((item) => item.description === invoiceDesc)
    ) {
      setMsgText("Please enter a different description name.");
      setMsgOpen(true);
    } else {
      setOpenInvoice(false);
      setConfirmFor("Invoice");
      setConfirmText(
        "Invoice label description and tax cannot be changed later. Do you wish to continue?"
      );
      setConfirmOpen(true);
    }
  };

  const handleActiveChange = (event, index) => {
    let invoiceList = [...invoiceLabels];
    invoiceList[index].active = event.target.checked;
    setInvoiceLabels(invoiceList);
  };
  const handleVehicleChange = (vehicleType) => {
    setSelectedVehicle(vehicleType);
  };

  const handleServiceReminder = (event) => {
    if (!localSettings.country.SMSEnabled && event.target.checked) {
      setMsgOpen(true);
      setMsgText(AlertSMSNotSupported);
      setSendServiceReminder(false);
      return;
    }
    setSendServiceReminder(event.target.checked);
  }

  const handleReservationReminder = (event) => {
    if (!localSettings.country.SMSEnabled && event.target.checked) {
      setMsgOpen(true);
      setMsgText(AlertSMSNotSupported);
      setSendReservationReminder(false);
      return;
    }
    setSendReservationReminder(event.target.checked);
  }

  const handleAutomaticMessage = (event) => {
    if (!localSettings.country.SMSEnabled && event.target.checked) {
      setMsgOpen(true);
      setMsgText(AlertSMSNotSupported);
    }
    setAutomaticMessage(event.target.checked)
  }
  const handleIsTaxBracket = (event) => {
    setIsTaxBracket(event)
    if (event === true) {
      setMsgOpen(true);
      setMsgText(
        "Enabling this feature will disable VAT for all transactions.<br><br>Please confirm that your business is eligible for VAT exemption as per local authority guidelines before proceeding."
      );
    }
  }

  const validateAndSetMuncipalTax = (event) => {
    var newValue = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(newValue)) {
      return;
    }
    setMunicipalTax(newValue);
  }

  const UploadReservationImage = async (event) => {
    var file = event.target.files[0];
    if (file.size > MaxFileSizeLimit) {
      setMsgText(
        "Unable to upload. File size exceeds the maximum limit, please ensure that it's less than 10 MB."
      );
      setMsgOpen(true);
      return;
    }
    var base64 = await convertBase64(file);
    setReservationImageUrl(base64);
  }

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const getImgObj = (selectedUrl) => {
    return {
      url: Utils.IsNullOrEmpty(selectedUrl)
        ? ""
        : selectedUrl.startsWith("http")
          ? selectedUrl
          : Utils.GetStringFromBase64(selectedUrl),
      newFile: !Utils.IsNullOrEmpty(selectedUrl) && !selectedUrl.startsWith("http"),
    };
  };

  const UploadPromotionalImages = async (event, index) => {
    var file = event.target.files[0];
    if (file.size > MaxFileSizeLimit) {
      setMsgText(
        "Unable to upload. File size exceeds the maximum limit, please ensure that it's less than 10 MB."
      );
      setMsgOpen(true);
      return;
    }
    var base64 = await convertBase64(file);
    setAddPromotionalImages((prev) => {
      const updated = [...prev];
      updated[index] = base64;
      return updated;
    });
  }

  const openImage = (url) => {
    setSelectedEnlargeImage(url);
    setEnlargeImage(true);
  };

  const closeImage = () => {
    setEnlargeImage(false);
  };
  const deleteReservationPhoto = (event) => {
    event.preventDefault();
    setConfirmFor("DeleteReservationPhoto");
    setConfirmText("Deleted images cannot be restored. Are you sure?");
    setConfirmOpen(true);
  }

  const deletePromotionalPhoto = (event, index) => {
    event.preventDefault();
    setConfirmFor("DeletePromotionalPhoto");
    setConfirmText("Deleted images cannot be restored. Are you sure?");
    setConfirmOpen(true);
    setSelectedDeleteImage(index);
  }

  const handleCloseConfirm = async (value) => {
    setConfirmOpen(false);
    switch (value) {
      case ConfirmTypes.OK:
      case ConfirmTypes.YES:
        setReservationImageUrl("");
        break;
    }
  };

  const handleCloseConfirmPromotional = async (value) => {
    setConfirmOpen(false);
    switch (value) {
      case ConfirmTypes.OK:
      case ConfirmTypes.YES:
        setAddPromotionalImages((prev) =>
          prev.filter((_, index) => index !== selectedDeleteImage)
        );
        break;
    }
  };


  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <ConfirmPopup
          confirmOpen={confirmOpen}
          confirmText={confirmText}
          onConfirmClose={handleConfirmClose}
        />

        {/*Invoice Label*/}
        <BootstrapDialog
          onClose={handleInvoiceClose}
          aria-labelledby="customized-dialog-title"
          open={openInvoice}
          className=""
          sx={{ "& .MuiDialog-paper": { width: 400, maxHeight: 300 } }}
          maxWidth="xs"
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleInvoiceClose}
          >
            <Typography
              level="h3"
              component="h3"
              fontWeight="600"
              fontSize="2rem"
              className="h3"
            >
              Invoice Label
            </Typography>
          </BootstrapDialogTitle>
          <DialogContent className="font-size-14">
            <Grid flex="1" spacing={2} className="mt-1">
              <FormControl fullWidth>
                <TextField
                  id="description"
                  label="Description"
                  variant="outlined"
                  value={invoiceDesc}
                  onChange={(e) => setInvoiceDesc(e.target.value)}
                />
              </FormControl>
              <Stack direction="row" spacing={2} className="mt-2">
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={invoiceTax}
                        onChange={(e) => setInvoiceTax(e.target.checked)}
                      />
                    }
                    label="Tax"
                  />
                </FormControl>
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={invoiceActive}
                        onChange={(e) => setInvoiceActive(e.target.checked)}
                      />
                    }
                    label="Active"
                  />
                </FormControl>
              </Stack>
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              className="mt-1 modal-footer"
            >
              <FormControl>
                <Button
                  className="btn btn-primary white-text"
                  variant="outlined"
                  onClick={handleInvoiceSave}
                >
                  Save
                </Button>
              </FormControl>
            </Stack>
          </DialogContent>
        </BootstrapDialog>

        {/*JobTypes*/}
        <BootstrapDialog
          onClose={handleJobTypeClose}
          aria-labelledby="customized-dialog-title"
          open={openJobType}
          className=""
          sx={{ "& .MuiDialog-paper": { width: 400, maxHeight: 300 } }}
          maxWidth="xs"
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleJobTypeClose}
          >
            <Typography
              level="h3"
              component="h3"
              fontWeight="600"
              fontSize="2rem"
              className="h3 text-center"
            >
              Add Job Type
            </Typography>
          </BootstrapDialogTitle>
          <DialogContent className="font-size-14">
            <Grid flex="1" className="mt-1">
              <FormControl fullWidth>
                <TextField
                  id="jobType"
                  label="Job Type"
                  variant="outlined"
                  value={jobType}
                  onChange={(e) => setJobType(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              className="mt-1"
            >
              <FormControl>
                <Button
                  className="btn btn-primary white-text"
                  variant="outlined"
                  onClick={handleJobTypeSave}
                >
                  Save
                </Button>
              </FormControl>
            </Stack>
          </DialogContent>
        </BootstrapDialog>

        {/*Inventory*/}
        <BootstrapDialog
          onClose={handleInventoryClose}
          aria-labelledby="customized-dialog-title"
          open={openInventory}
          className=""
          sx={{ "& .MuiDialog-paper": { width: 400, maxHeight: 300 } }}
          maxWidth="xs"
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleInventoryClose}
          >
            <Typography
              level="h3"
              component="h3"
              fontWeight="600"
              fontSize="2rem"
              className="h3 text-center"
            >
              Add Inventory Item
            </Typography>
          </BootstrapDialogTitle>
          <DialogContent className="font-size-14">
            <Grid flex="1" spacing={2} className="mt-1">
              <FormControl fullWidth>
                <TextField
                  id="inventory"
                  label="Inventory Item"
                  variant="outlined"
                  value={inventory}
                  onChange={(e) => setInventory(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              className="mt-1"
            >
              <FormControl>
                <Button
                  className="btn btn-primary white-text"
                  variant="outlined"
                  onClick={handleInventorySave}
                >
                  Save
                </Button>
              </FormControl>
            </Stack>
          </DialogContent>
        </BootstrapDialog>
        <ImageEnlarge open={enlargeImage} imgSrc={selectedEnlargeImage} onClose={closeImage} />

        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.BusinessSetup} />
            <Grid xs={12} className="content-sec">
              <Grid container direction="row">
                <SettingsMenuItems
                  selectedMenu={SettingsMenuList.BusinessSettings.BranchSetup}
                />
                <Grid flex="1" spacing={2} className="form-sec card white-bg">
                  <form
                    method="post"
                    className="cs-form text-left"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                    style={{ paddingBottom: "30px" }}
                  >
                    <Stack sx={{ minWidth: 120 }} spacing={2}>
                      <FormControl fullWidth>
                        <TextField
                          id="branchName"
                          label="Branch Name"
                          variant="outlined"
                          error={!branchName}
                          value={branchName}
                          onChange={(e) => setBranchName(e.target.value)}
                          placeholder="Enter branch name"
                        />
                      </FormControl>
                      {!Utils.IsNullOrEmpty(branchAddressISOCode) && (<FormControl fullWidth>
                        <AddressField
                          value={branchAddress}
                          setValue={setBranchAddress}
                          countryISoCode={branchAddressISOCode}
                          isValidate={true}
                          label="Branch Address"
                          variant="outlined"
                          required
                          id="branchAddress"
                        />
                      </FormControl>)}
                      {!BusinessHelper.IsSalon() && (
                        <FormControl fullWidth>
                          <TextField
                            id="registrationId"
                            label={taxIdLbl}
                            variant="outlined"
                            value={registrationId}
                            onChange={(e) => setRegistrationId(e.target.value.toUpperCase())}
                            inputProps={{ maxLength: 15 }}
                          />
                        </FormControl>
                      )}
                      {!BusinessHelper.IsSalon() &&
                        businessCountry &&
                        businessCountry == India.ShortName && (
                          <FormControl fullWidth>
                            <TextField
                              id="GSTNStateCode"
                              label="GSTN State Code"
                              variant="outlined"
                              value={stateCode}
                              onChange={(e) => setStateCode(e.target.value)}
                            />
                          </FormControl>
                        )}

                      <FormControl fullWidth>
                        <TextField
                          id="BranchgoogleReviewURL"
                          label="Google Review URL"
                          variant="outlined"
                          value={googleReviewURL}
                          error={!Utils.IsNullOrEmpty(googleReviewURL) ? "" : Utils.IsURLValid(googleReviewURL)}
                          onChange={(e) => setGoogleReviewURL(e.target.value)}
                          placeholder="Enter url"
                        />
                      </FormControl>

                      {!BusinessHelper.IsSalon() && (
                        <FormControl fullWidth>
                          <Stack direction="row" alignItems={"center"}>
                            <Typography
                              level="h3"
                              component="h3"
                              fontWeight="600"
                              fontSize="1.5rem"
                              className="section-title"
                            >
                              Vehicles Handled
                            </Typography>
                            <Radio
                              disabled={!Utils.IsNullOrEmptyObject(selectedBranch)}
                              checked={selectedVehicle === VehicleTypes.FourWheeler}
                              onClick={() => handleVehicleChange(VehicleTypes.FourWheeler)}
                            />
                            <Typography
                              level="h4"
                              component="h4"
                              fontSize="1.3rem"
                            >
                              Four Wheeler
                            </Typography>
                            <Radio
                              disabled={!Utils.IsNullOrEmptyObject(selectedBranch)}
                              checked={selectedVehicle === VehicleTypes.TwoWheeler}
                              onClick={() => handleVehicleChange(VehicleTypes.TwoWheeler)}
                            />
                            <Typography
                              level="h4"
                              component="h4"
                              fontSize="1.3rem"
                            >
                              Two Wheeler
                            </Typography>
                          </Stack>
                        </FormControl>
                      )}
                      <Stack direction="row" spacing={2} className="font-size-14">
                        {isAutomobile && (
                          <>
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={fetchServiceLocations}
                                    onChange={(e) =>
                                      setFetchServiceLocations(e.target.checked)
                                    }
                                  />
                                }
                                label="Record Service Location"
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={isOdometerReadingsMandatory}
                                    onChange={(e) =>
                                      setIsOdometerReadingsMandatory(
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                                label="Odometer Mandatory"
                              />
                            </FormControl>
                          </>
                        )}
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={automaticMessage}
                                onChange={(e) => handleAutomaticMessage(e)}
                              />
                            }
                            label="Send Automatic Message"
                          />
                        </FormControl>

                        {BusinessHelper.IsSalon() && <FormControl fullWidth>
                          <Tooltip direction="row" alignItems="center" title="Stylist assignment required" arrow>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={isAllowStylists}
                                  onChange={(e) =>
                                    setIsAllowStylists(e.target.checked)
                                  }
                                />
                              }
                              label="Assigning Stylist for Service is Mandatory"
                            />
                          </Tooltip>
                        </FormControl>}
                      </Stack>
                      <Stack direction="row" spacing={2} className="font-size-14">
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isDescriptionInInvoice}
                                onChange={(e) =>
                                  setIsDescriptionInInvoice(e.target.checked)
                                }
                              />
                            }
                            label="Allow Description In Invoice"
                          />
                        </FormControl>
                        {isProductStockReport && (
                          <FormControl fullWidth>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={isBillingInventoryTrack}
                                  onChange={(e) =>
                                    setIsBillingInventoryTrack(e.target.checked)
                                  }
                                />
                              }
                              label="Inventory Tracking"
                            />
                          </FormControl>
                        )}
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isBackDateInvoice}
                                onChange={(e) =>
                                  setIsBackDateInvoice(e.target.checked)
                                }
                              />
                            }
                            label="Backdate Invoice"
                          />
                        </FormControl>
                      </Stack>
                      <Stack direction="row" className="font-size-14">
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isAuthenticationPinRequired}
                                onChange={(e) =>
                                  setIsAuthenticationPinRequired(e.target.checked)
                                }
                              />
                            }
                            label="Authentication Pin Required"
                          />
                        </FormControl>
                        {businessCountry.ShortName == UAE.ShortName && (
                          <FormControl fullWidth>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={isTaxBracket}
                                  onChange={(e) =>

                                    handleIsTaxBracket(e.target.checked)
                                  }
                                />
                              }
                              label="Tax Brackets"
                            />
                          </FormControl>
                        )}
                        {isAutomobile && <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isIssueApprovalRequired}
                                onChange={(e) =>
                                  setIsIssueApprovalRequired(e.target.checked)
                                }
                              />
                            }
                            label="Issue Approval Required"
                          />
                        </FormControl>}
                      </Stack>
                      {isTaxBracket && (
                        <Stack alignItems="center">
                          <div
                            style={{
                              backgroundColor: "#fdecea",
                              color: "#b71c1c",
                              padding: "12px 16px",
                              border: "1px solid #f5c6cb",
                              borderRadius: "4px",
                              width: "100%",
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            VAT has been disabled. Please ensure your business complies with local tax regulations.
                          </div>
                        </Stack>
                      )}
                      {businessCountry && businessCountry == USA.ShortName && (
                        <Stack direction="row" spacing={2}>
                          <FormControl fullWidth>
                            <TextField
                              id="taxPercent"
                              label="Tax Percent"
                              variant="outlined"
                              value={taxPercent}
                              required
                              onChange={(e) => setTaxPercent(e.target.value)}
                            />
                          </FormControl>
                          <FormControl fullWidth>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={corporate}
                                  onChange={(e) => setCorporate(e.target.value)}
                                />
                              }
                              label="Corporate"
                            />
                          </FormControl>
                        </Stack>
                      )}

                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Payment
                      </Typography>
                      <Stack className="card font-size-14" padding="10px">
                        <Stack direction="row">
                          <FormControl fullWidth>
                            <Box>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={allowPaymentLinks}
                                    onChange={(e) =>
                                      setAllowPaymentLinks(e.target.checked)
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    name="Allow Payment Links"
                                    color="primary"
                                  />
                                }
                                label="Allow Payment Links"
                                labelPlacement="end"
                              />
                            </Box>
                          </FormControl>
                          <FormControl fullWidth>
                            <Box>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={allowPartialPayments}
                                    onChange={(e) => setAllowPartialPayments(e.target.checked)}
                                    InputLabelProps={{ shrink: true }}
                                    name="Allow Partial Payment"
                                    color="primary"
                                  />
                                }
                                label="Allow Partial Payment"
                                labelPlacement="end"
                              />
                            </Box>
                          </FormControl>
                        </Stack>
                      </Stack>
                      <Stack
                        direction="row"
                        alignContent="space-between"
                        justifyContent="space-between"
                      >
                        <Typography
                          level="h3"
                          component="h3"
                          className="section-title"
                        >
                          Invoice Label
                        </Typography>
                        <IconButton
                          name="addInvoiceLabel"
                          onClick={() => {
                            handleAddInvoice();
                          }}
                        >
                          <AddCircleIcon fontSize="large" />
                        </IconButton>
                      </Stack>
                      {!Utils.IsNullOrEmptyArray(invoiceLabels) && (
                        <TableContainer component={Paper} className="data-grid font-size-14">
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="invoice table"
                          >
                            <TableBody>
                              {invoiceLabels.map((row, index) => (
                                <TableRow
                                  key={row.invoiceNumber}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.description}
                                  </TableCell>
                                  <TableCell>
                                    <FormControl fullWidth>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={row.taxIncluded}
                                            disabled
                                          />
                                        }
                                        label="Tax"
                                      />
                                    </FormControl>
                                  </TableCell>
                                  <TableCell>
                                    <FormControl fullWidth>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={row.active}
                                            onChange={(e) =>
                                              handleActiveChange(e, index)
                                            }
                                          />
                                        }
                                        label="Active"
                                      />
                                    </FormControl>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                      {/* <Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Payment
                      </Typography>
                      <Stack className="card font-size-14" padding="10px">
                        <Stack direction="row">
                          <FormControl fullWidth>
                            <Box>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={allowPaymentLinks}
                                    onChange={(e) =>
                                      setAllowPaymentLinks(e.target.checked)
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    name="Allow Payment Links"
                                    color="primary"
                                  />
                                }
                                label="Allow Payment Links"
                                labelPlacement="end"
                              />
                            </Box>
                          </FormControl>
                          <FormControl fullWidth>
                            <Box>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={allowPartialPayments}
                                    onChange={(e) => setAllowPartialPayments(e.target.checked)}
                                    InputLabelProps={{ shrink: true }}
                                    name="Allow Partial Payment"
                                    color="primary"
                                  />
                                }
                                label="Allow Partial Payment"
                                labelPlacement="end"
                              />
                            </Box>
                          </FormControl>
                        </Stack>
                      </Stack> */}
                      {/* <Stack
                        direction="row"
                        alignContent="space-between"
                        justifyContent="space-between"
                      >
                        <Typography
                          level="h3"
                          component="h3"
                          className="section-title"
                        >
                          Invoice Label
                        </Typography>
                        <IconButton
                          name="addInvoiceLabel"
                          onClick={() => {
                            handleAddInvoice();
                          }}
                        >
                          <AddCircleIcon fontSize="large" />
                        </IconButton>
                      </Stack> */}
                      {/* {!Utils.IsNullOrEmptyArray(invoiceLabels) && (
                        <TableContainer component={Paper} className="data-grid font-size-14">
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="invoice table"
                          >
                            <TableBody>
                              {invoiceLabels.map((row, index) => (
                                <TableRow
                                  key={row.invoiceNumber}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.description}
                                  </TableCell>
                                  <TableCell>
                                    <FormControl fullWidth>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={row.taxIncluded}
                                            disabled
                                          />
                                        }
                                        label="Tax"
                                      />
                                    </FormControl>
                                  </TableCell>
                                  <TableCell>
                                    <FormControl fullWidth>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={row.active}
                                            onChange={(e) =>
                                              handleActiveChange(e, index)
                                            }
                                          />
                                        }
                                        label="Active"
                                      />
                                    </FormControl>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )} */}

                      <Stack direction="row" spacing={2}>
                        <FormControl fullWidth>
                          <TextField
                            id="invoicePrefix"
                            label="Invoice Prefix"
                            variant="outlined"
                            value={invoicePrefix}
                            onChange={(e) => setInvoicePrefix(e.target.value)}
                            placeholder="Enter prefix"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <TextField
                            id="invoiceSuffix"
                            label="Invoice Suffix"
                            variant="outlined"
                            value={invoiceSuffix}
                            onChange={(e) => setInvoiceSuffix(e.target.value)}
                            placeholder="Enter suffix"
                          />
                        </FormControl>
                      </Stack>

                      {CountryHelper.IsBusinessCountryUAE() && <Stack
                        direction="row"
                        alignContent="space-between"
                        justifyContent="space-between"
                      >
                        <Typography
                          level="h3"
                          component="h3"
                          className="section-title"
                        >
                          Municipality Tax
                        </Typography>
                      </Stack>}



                      {CountryHelper.IsBusinessCountryUAE() && <Stack direction="row" spacing={2}>
                        <FormControl >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isAllowMunicipalTax}
                                onChange={(e) =>
                                  setIsAllowMunicipalTax(e.target.checked)
                                }
                              />
                            }
                            label="Municipal Tax Applicable"
                            sx={{
                              '.MuiFormControlLabel-label': {
                                fontSize: '1.5rem'
                              }
                            }}
                          />
                        </FormControl>
                        {isAllowMunicipalTax && <FormControl>
                          <InputLabel htmlFor="MuncipalTax">Municipal Tax</InputLabel>
                          <OutlinedInput
                            id="MuncipalTax"
                            variant="outlined"
                            value={municipalTax}
                            onChange={(e) => validateAndSetMuncipalTax(e)}
                            placeholder="Enter Tax %"
                            endAdornment={<InputAdornment position="end"> <span style={{ fontSize: '1.5rem' }}>%</span></InputAdornment>}
                            InputLabelProps={{ shrink: true }}
                            label="Municipal Tax"
                          />
                        </FormControl>}
                      </Stack>}

                      {CanUseWarrantyDetails() && <><Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Warranty Label
                      </Typography>
                        <FormControl fullWidth>
                          <TextField
                            id="warrantyPrefix"
                            label="Warranty Prefix"
                            variant="outlined"
                            value={warrantyPrefix}
                            onChange={(e) => setwarrantyPrefix(e.target.value)}
                            placeholder="Enter Prefix"
                          />
                        </FormControl></>

                      }

                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Contact Info
                      </Typography>
                      <FormControl fullWidth>
                        <TextField
                          id="contactName"
                          label="Name "
                          variant="outlined"
                          error={!contactName}
                          value={contactName}
                          onChange={(e) => setContactName(e.target.value)}
                          placeholder="Enter name"
                        />
                      </FormControl>
                      <Stack direction="row" spacing={2}>
                        <FormControl fullWidth>
                          <NumericTextField
                            id="contactPhoneNumber"
                            label="Mobile Number "
                            type="tel"
                            variant="outlined"
                            inputProps={{
                              maxLength: CountryHelper.GetMobileNumberMaxLength(),
                            }}
                            error={!Utils.IsMobileValid(contactPhoneNumber)}
                            value={contactPhoneNumber}
                            setValue={setContactPhoneNumber}
                            placeholder="Enter mobile number"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <NumericTextField
                            id="additionalPhoneNumber"
                            label="Additional Phone Number"
                            type="tel"
                            variant="outlined"
                            inputProps={{
                              maxLength: CountryHelper.GetMobileNumberMaxLength(),
                            }}
                            value={additionalPhoneNumber}
                            setValue={setAdditionalPhoneNumber}
                            placeholder="Enter phone number"
                          />
                        </FormControl>
                      </Stack>
                      <FormControl fullWidth>
                        <TextField
                          id="contactEmail"
                          label="Email "
                          type="email"
                          variant="outlined"
                          value={contactEmail}
                          error={!contactEmail}
                          onChange={(e) => setContactEmail(e.target.value)}
                          placeholder="Enter email"
                        />
                      </FormControl>
                      <FormControl fullWidth>
                        <TextField
                          id="receiptCaption"
                          label="Receipt Footer Caption"
                          variant="outlined"
                          value={receiptCaption}
                          onChange={(e) => setReceiptCaption(e.target.value)}
                          placeholder="Enter caption"
                        />
                      </FormControl>
                      {businessCountry && businessCountry == USA.ShortName && (
                        <>
                          <Typography
                            level="h3"
                            component="h3"
                            className="section-title"
                          >
                            Payment Settings
                          </Typography>
                          <Stack direction="row" spacing={2}>
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={payments}
                                    onChange={(e) => setPayments(e.target.value)}
                                  />
                                }
                                label="Payments"
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={payouts}
                                    onChange={(e) => setPayouts(e.target.value)}
                                  />
                                }
                                label="Payouts"
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={autoPay}
                                    onChange={(e) => setAutoPay(e.target.value)}
                                  />
                                }
                                label="Auto Pay"
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={immediate}
                                    onChange={(e) => setImmediate(e.target.value)}
                                  />
                                }
                                label="Immediate"
                              />
                            </FormControl>
                          </Stack>
                        </>
                      )}
                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Reservation Settings
                      </Typography>
                      <Stack direction="row" spacing={2} className="font-size-14">
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={acceptReservations}
                                onChange={(e) =>
                                  setAcceptReservations(e.target.checked)
                                }
                              />
                            }
                            label="Accept Reservations"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <TimePicker
                              id="businessOpen"
                              label="Business Open"
                              value={moment(businessOpen, "HH:mm:ss")}
                              onChange={(newValue) => setBusinessOpen(newValue)}
                              ampm={false}
                            />
                          </LocalizationProvider>
                        </FormControl>
                        <FormControl fullWidth>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <TimePicker
                              id="businessClose"
                              label="Business Close"
                              value={moment(businessClose, "HH:mm:ss")}
                              onChange={(newValue) => setBusinessClose(newValue)}
                              ampm={false}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </Stack>
                      <Stack direction="row" spacing={2} className="font-size-14">
                        <FormControl fullWidth>
                          {acceptReservations ? (
                            <>
                              <FormControl fullWidth>
                                <NumericTextField
                                  id="maxDays"
                                  label="Max Days"
                                  variant="outlined"
                                  inputProps={{ maxLength: 5 }}
                                  value={maxDays}
                                  error={!maxDays}
                                  setValue={setMaxDays}
                                  placeholder="Enter max days"
                                />
                              </FormControl>
                            </>) : (
                            <>
                              <FormControl fullWidth>
                                <NumericTextField
                                  id="maxDays"
                                  label="Max Days"
                                  variant="outlined"
                                  inputProps={{ maxLength: 5 }}
                                  value={maxDays}
                                  setValue={setMaxDays}
                                  placeholder="Enter max days"
                                />
                              </FormControl>
                            </>)}
                        </FormControl>
                        <FormControl fullWidth>

                          {acceptReservations ? (
                            <>
                              <NumericTextField
                                id="timeSlotIntMins"
                                label="Time Slot Interval Minutes"
                                variant="outlined"
                                inputProps={{ maxLength: 3 }}
                                value={timeSlotIntMins}
                                error={!timeSlotIntMins}
                                setValue={setTimeSlotIntMins}
                                placeholder="Enter minutes"
                              />
                            </>) : (
                            <>
                              <NumericTextField
                                id="timeSlotIntMins"
                                label="Time Slot Interval Minutes"
                                variant="outlined"
                                inputProps={{ maxLength: 3 }}
                                value={timeSlotIntMins}
                                setValue={setTimeSlotIntMins}
                                placeholder="Enter minutes"
                              />
                            </>)}
                        </FormControl>
                        <FormControl fullWidth>
                          {acceptReservations ? (
                            <>
                              <NumericTextField
                                id="reservationsPerTimeSlot"
                                label="Reservations Per Time Slot"
                                variant="outlined"
                                inputProps={{ maxLength: 3 }}
                                value={reservationsPerTimeSlot}
                                error={!reservationsPerTimeSlot}
                                setValue={setReservationsPerTimeSlot}
                              />
                            </>) : (
                            <>
                              <NumericTextField
                                id="reservationsPerTimeSlot"
                                label="Reservations Per Time Slot"
                                variant="outlined"
                                inputProps={{ maxLength: 3 }}
                                value={reservationsPerTimeSlot}
                                setValue={setReservationsPerTimeSlot}
                              />
                            </>)}
                        </FormControl>
                      </Stack>
                      <Stack direction="row" spacing={2} className="font-size-14">
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={reserveService}
                                onChange={(e) =>
                                  setReserveService(e.target.checked)
                                }
                              />
                            }
                            label="Reserve Service"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={reservationAtUserLevel}
                                onChange={(e) =>
                                  setReservationAtUserLevel(e.target.checked)
                                }
                              />
                            }
                            label="Customer can reserve with specific employee"
                          />
                        </FormControl>
                        {businessCountry && businessCountry == USA.ShortName && (
                          <FormControl fullWidth>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={reservationConfirmedByCustomer}
                                  onChange={(e) =>
                                    setReservationConfirmedByCustomer(
                                      e.target.checked
                                    )
                                  }
                                />
                              }
                              label="Customer to confirm reservation"
                            />
                          </FormControl>
                        )}
                      </Stack>
                    </Stack>
                    {businessCountry && businessCountry == USA.ShortName && (
                      <>
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={reservationPaymentRequired}
                                onChange={(e) =>
                                  setReservationPaymentRequired(e.target.checked)
                                }
                              />
                            }
                            label="Payment Required"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          {reservationPaymentRequired ? (
                            <>
                              <NumericTextField
                                id="reservationPaymentPercent"
                                label="Payment Percent"
                                variant="outlined"
                                inputProps={{ maxLength: 5 }}
                                value={reservationPaymentPercent}
                                error={!reservationPaymentPercent}
                                setValue={setReservationPaymentPercent}
                              />
                            </>) : (
                            <>
                              <NumericTextField
                                id="reservationPaymentPercent"
                                label="Payment Percent"
                                variant="outlined"
                                inputProps={{ maxLength: 5 }}
                                value={reservationPaymentPercent}
                                setValue={setReservationPaymentPercent}
                              />
                            </>)}
                          <NumericTextField
                            id="reservationPaymentPercent"
                            label={
                              reservationPaymentRequired
                                ? "Payment Percent *"
                                : "Payment Percent"
                            }
                            variant="outlined"
                            inputProps={{ maxLength: 5 }}
                            value={reservationPaymentPercent}
                            setValue={setReservationPaymentPercent}
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={reservationPaymentRefundable}
                                onChange={(e) =>
                                  setReservationPaymentRefundable(
                                    e.target.checked
                                  )
                                }
                              />
                            }
                            label="Payment Refundable"
                          />
                        </FormControl>
                      </>
                    )}
                    {(BusinessHelper.IsSalon() || BusinessHelper.IsAutomobile()) && acceptReservations && <Box>
                      <Stack mb={2} direction="row" spacing={2} justifyContent="space-between" className="font-size-14 mt-3 w-100">
                        <Typography
                          level="h3"
                          component="h3"
                          className="section-title"
                        >
                          Background Image for Reservation Link
                        </Typography>
                      </Stack>
                      {Utils.IsNullOrEmpty(reservationImageUrl) && <Stack direction="row">
                        <label>
                          <AddAPhotoIcon fontSize="large" style={{ cursor: "pointer" }} />
                          <Input
                            type="file"
                            name="myImage"
                            className="hide"
                            inputProps={{
                              accept:
                                "image/png, image/jpeg, image/ico, image/jpg",
                            }}
                            onChange={(e) => UploadReservationImage(e)}
                          />
                        </label>
                      </Stack>}
                      {!Utils.IsNullOrEmpty(reservationImageUrl) && (
                        <Grid className="card imgBox">
                          <img
                            alt="not found"
                            width={"150px"}
                            src={reservationImageUrl}
                            onClick={(e) => openImage(reservationImageUrl)}
                            style={{ cursor: "pointer" }}
                          />
                          <br />
                          <button
                            className="p-0 mt-1 btn btn-default"
                            onClick={deleteReservationPhoto}
                            style={{ cursor: "pointer" }}
                          >
                            <DeleteIcon />
                          </button>
                        </Grid>
                      )}
                    </Box>}
                    <Stack mb={2} direction="row" spacing={2} justifyContent="space-between" className="mt-3 w-100">
                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Add Promotional Images - Infopass
                      </Typography>

                    </Stack>
                    {Utils.IsNullOrEmptyArray(addPromotionalImages) && <Stack direction="row">
                      <label>
                        <AddAPhotoIcon fontSize="large" style={{ cursor: "pointer" }} />
                        <Input
                          type="file"
                          name="myImage"
                          className="hide"
                          inputProps={{
                            accept:
                              "image/png, image/jpeg, image/ico, image/jpg",
                          }}
                          onChange={(e) => UploadPromotionalImages(e, 0)}
                        />
                      </label>
                    </Stack>}
                    {!Utils.IsNullOrEmptyArray(addPromotionalImages) && (
                      <Stack direction="row" spacing={2} className="card imgBox">
                        {addPromotionalImages.map((item, i) => (
                          <Box>
                            <img
                              alt="not found"
                              width={"150px"}
                              height={"120px"}
                              src={item}
                              onClick={((e) => openImage(item))}
                              style={{ cursor: "pointer" }}
                            />
                            <br />
                            <button
                              className="p-0 mt-1 btn btn-default"
                              onClick={(e) => deletePromotionalPhoto(e, i)}
                              style={{ cursor: "pointer" }}
                            >
                              <DeleteIcon />
                            </button>
                          </Box>
                        ))}
                        {addPromotionalImages.length < 4 && <label style={{ marginLeft: "50px", marginTop: "50px" }}>
                          <AddAPhotoIcon fontSize="large" style={{ cursor: "pointer" }} />
                          <Input
                            type="file"
                            name="myImage"
                            className="hide"
                            inputProps={{
                              accept:
                                "image/png, image/jpeg, image/ico, image/jpg",
                            }}
                            onChange={(e) => UploadPromotionalImages(e, addPromotionalImages.length)}
                          />
                        </label>}
                      </Stack>
                    )}
                    {BusinessHelper.IsSalon() && (
                      <>
                        <Stack spacing={2} className="mt-3">
                          <Typography
                            level="h3"
                            component="h3"
                            className="section-title"
                          >
                            Service Reminder Settings
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <FormControl>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={sendReservationReminder}
                                    onChange={(e) => handleReservationReminder(e)}
                                  />
                                }
                                label="Send Service Reminder"
                              />
                            </FormControl>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <TimePicker
                                id="sendReminderAt"
                                label="Send Reminder At"
                                value={moment(
                                  sendReminderTriggerTime,
                                  "HH:mm:ss tt"
                                )}
                                onChange={(newValue) =>
                                  setSendReminderTriggerTime(newValue)
                                }
                              />
                            </LocalizationProvider>
                          </Stack>
                        </Stack>
                      </>
                    )}
                    {isAutomobile && (
                      <>
                        <Stack spacing={2} className="mt-3">
                          <Typography
                            level="h3"
                            component="h3"
                            className="section-title"
                          >
                            Service Reminder Settings
                          </Typography>
                          <Stack direction="row" spacing={2} className="font-size-14">
                            <FormControl fullWidth>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={sendServiceReminder}
                                    onChange={(e) => handleServiceReminder(e)}
                                  />
                                }
                                label="Send Service Reminder"
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <NumericTextField
                                id="daysToRemindBeforeService"
                                label="Days to remind before service"
                                variant="outlined"
                                inputProps={{ maxLength: 5 }}
                                value={daysToRemindBeforeService}
                                setValue={setDaysToRemindBeforeService}
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <LocalizationProvider dateAdapter={AdapterMoment}>
                                <TimePicker
                                  id="sendReminderAt"
                                  label="Send Reminder At"
                                  value={moment(
                                    sendReminderTriggerTime,
                                    "HH:mm:ss tt"
                                  )}
                                  onChange={(newValue) =>
                                    setSendReminderTriggerTime(newValue)
                                  }
                                />
                              </LocalizationProvider>
                            </FormControl>
                          </Stack>
                        </Stack>
                        <Grid container spacing={2} className="mt-1">
                          <Grid item xs={12} md={12} lg={12} spacing={2}>
                            <Stack
                              spacing={2}
                              direction="row"
                              alignContent="space-between"
                              justifyContent="space-between"
                            >
                              <Typography
                                level="h3"
                                component="h3"
                                className="section-title"
                              >
                                Job Types
                              </Typography>
                              <IconButton
                                name="addInvoiceLabel"
                                onClick={() => {
                                  handleJobTypeAdd();
                                }}
                              >
                                <AddCircleIcon fontSize="large" />
                              </IconButton>
                            </Stack>
                            {!Utils.IsNullOrEmptyArray(jobTypes) && (
                              <TableContainer
                                component={Paper}
                                className="data-grid font-size-13"
                              >
                                <Table
                                  size="small"
                                  sx={{ minWidth: 650 }}
                                  aria-label="job types table"
                                >
                                  <TableBody>
                                    {jobTypes.map((row, index) => (
                                      <TableRow
                                        key={index}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          style={{ width: "90px" }}
                                        >
                                          <IconButton
                                            name="deleteJobType"
                                            onClick={() => {
                                              handleJobTypeDelete(index);
                                            }}
                                            style={{ color: "red" }}
                                          >
                                            <DeleteOutlineIcon fontSize="large" />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>{row}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )}
                          </Grid>
                          <Grid item xs={12} md={12} lg={12} spacing={2}>
                            <Stack
                              spacing={2}
                              direction="row"
                              alignContent="space-between"
                              justifyContent="space-between"
                            >
                              <Typography
                                level="h3"
                                component="h3"
                                className="section-title"
                              >
                                Inventory Items
                              </Typography>
                              <IconButton
                                name="addInventory"
                                onClick={() => {
                                  handleInventoryAdd();
                                }}
                              >
                                <AddCircleIcon fontSize="large" />
                              </IconButton>
                            </Stack>
                            {!Utils.IsNullOrEmptyArray(inventoryItems) && (
                              <TableContainer
                                component={Paper}
                                className="data-grid td, .data-grid th font-size-14"
                              >
                                <Table
                                  size="small"
                                  sx={{ minWidth: 0, marginBottom: "10px" }}
                                  aria-label="inventory table"
                                >
                                  <TableBody>
                                    {inventoryItems.map((row, index) => (
                                      <TableRow
                                        key={index}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          style={{ width: "90px" }}
                                        >
                                          <IconButton
                                            name="deleteInventory"
                                            onClick={() => {
                                              handleInventoryDelete(index);
                                            }}
                                            style={{ color: "red" }}
                                          >
                                            <DeleteOutlineIcon fontSize="large" />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>
                                          <FormControl fullWidth sx={{ alignItems: "end" }}>
                                            <FormControlLabel
                                              sx={{ position: "relative", top: "6px" }}
                                              control={
                                                <Switch
                                                  checked={row.isChecked}
                                                  onChange={(e) =>
                                                    handleCommentsChange(e, index)
                                                  }
                                                />
                                              }
                                              label="Comments"
                                            />
                                          </FormControl>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )}
                          </Grid>
                        </Grid>
                      </>
                    )}
                    <Stack>&nbsp;</Stack>
                    <Stack
                      direction="row"
                      className="fixed-btn"
                    >
                      <Grid className="container"
                        justifyContent="end"
                      >
                        <Stack direction="row" justifyContent="end">
                          <FormControl>
                            <Button
                              type="submit"
                              variant="contained"
                              className="btn btn-primary"
                            >
                              Save
                            </Button>
                          </FormControl>
                        </Stack>
                      </Grid>
                    </Stack>
                  </form>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default AddNewBranch;
